module.exports = __webpack_public_path__ + "media/images/2024_fanclub_card_tokyo-406e3e82681ecdad5777665bf500f37e.png";